export default "__VITE_ASSET__DCEfDknV__"